import * as echarts from 'echarts/core';
import { LineChart, BarChart, PieChart, ScatterChart } from 'echarts/charts';
import {
    GridComponent,
    TooltipComponent,
    LegendComponent,
    MarkLineComponent,
    MarkAreaComponent,
    BrushComponent,
    ToolboxComponent,
} from 'echarts/components';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { LegacyGridContainLabel } from 'echarts/features';

echarts.use([
    LineChart,
    BarChart,
    PieChart,
    ScatterChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    MarkLineComponent,
    MarkAreaComponent,
    BrushComponent,
    ToolboxComponent,
    LegacyGridContainLabel,
    CanvasRenderer,
    SVGRenderer,
]);

export type EChartsInstance = echarts.ECharts;
export type EChartsCoreOption = echarts.EChartsCoreOption;
export type EChartClickParams = {
    seriesName?: string;
    name?: string;
    value?: unknown;
    percent?: number;
    color?: unknown;
    data?: any;
};

export function getInitOptions(): { renderer: 'svg' | 'canvas'; width?: number; height?: number } {
    return process.env.NODE_ENV === 'test'
        ? { renderer: 'svg', width: 600, height: 200 }
        : { renderer: 'svg' };
}

export default echarts;
